module.exports = __webpack_public_path__ + "img/icon-pinjaman-lainnya.91bf6077.svg";